module.exports = __webpack_public_path__ + "02af6fa3548ebaa1204fac8bfb16ed6d.jpg";